import { Config } from "../config";
import { Service } from ".";

export const TransferOptionsService = {
    /**
     * [LIST]
     */
    List() {

        var requestOptions = {
            method: 'Get',
            headers: Config.utilities.authorizedHeader()
        }

        return TransferOptionsService.Common.Fetch(Config.service.transferOptions.list, requestOptions);

    },
    /**
     * [DETAIL]
     */
    Detail(id) {

        var requestOptions = {
            method: 'Post',
            headers: Config.utilities.authorizedHeader(),
            body: JSON.stringify({ id: id })
        }

        return TransferOptionsService.Common.Fetch(Config.service.transferOptions.detail, requestOptions);

    },
    /**
     * [Save]
     */
    Save(formData) {

        var requestOptions = {
            method: 'Post',
            headers: Config.utilities.authorizedHeader(),
            body: JSON.stringify(formData)
        }

        return TransferOptionsService.Common.Fetch(Config.service.transferOptions.save, requestOptions);

    },
    /**
     * [CURRENCY_LIST]
     */
    CurrencyList() {

        var requestOptions = {
            method: 'Get',
            headers: Config.utilities.authorizedHeader()
        }

        return TransferOptionsService.Common.Fetch(Config.service.transferOptions.currencyList, requestOptions);

    },
    /**
     * [RULES]
     */
    Rules() {

        var requestOptions = {
            method: 'Get',
            headers: Config.utilities.authorizedHeader()
        }

        return TransferOptionsService.Common.Fetch(Config.service.transferOptions.rules, requestOptions);

    },
    /**
    * [DAILY_LIMIT]
    */
    DailyLimit() {

        var requestOptions = {
            method: 'Get',
            headers: Config.utilities.authorizedHeader()
        }

        return TransferOptionsService.Common.Fetch(Config.service.transferOptions.dailyLimit, requestOptions);

    },
    /**
    * [DAILY_LIMIT]
    */
    DailyLimitSave(formData) {

        var requestOptions = {
            method: 'Post',
            headers: Config.utilities.authorizedHeader(),
            body: JSON.stringify(formData)
        }

        return TransferOptionsService.Common.Fetch(Config.service.transferOptions.dailyLimitSave, requestOptions);

    },
    /**
    * [BLACK_LIST]
    */
    BlackList() {

        var requestOptions = {
            method: 'Get',
            headers: Config.utilities.authorizedHeader()
        }

        return TransferOptionsService.Common.Fetch(Config.service.transferOptions.blackList, requestOptions);

    },
    /**
    * [BLACK_LIST_SAVE]
    */
    BlackListSave(formData) {

        var requestOptions = {
            method: 'Post',
            headers: Config.utilities.authorizedHeader(),
            body: JSON.stringify(formData)
        }

        return TransferOptionsService.Common.Fetch(Config.service.transferOptions.blackListSave, requestOptions);

    },
    /**
    * [BLACK_LIST_EDIT]
    */
    BlackListEdit(id) {

        var requestOptions = {
            method: 'Post',
            headers: Config.utilities.authorizedHeader(),
            body: JSON.stringify({ id: id })
        }

        return TransferOptionsService.Common.Fetch(Config.service.transferOptions.blackListEdit, requestOptions);

    },
    /**
    * [BLACK_LIST_DELETE]
    */
    BlackListDelete(id) {

        var requestOptions = {
            method: 'Post',
            headers: Config.utilities.authorizedHeader(),
            body: JSON.stringify({ id: id })
        }

        return TransferOptionsService.Common.Fetch(Config.service.transferOptions.blackListDelete, requestOptions);

    },
    /**
    * [WHITE_LIST]
    */
    WhiteList() {

        var requestOptions = {
            method: 'Get',
            headers: Config.utilities.authorizedHeader()
        }

        return TransferOptionsService.Common.Fetch(Config.service.transferOptions.whiteList, requestOptions);

    },
    /**
  * [WHITE_LIST_DELETE]
  */
    WhiteListDelete(id) {

        var requestOptions = {
            method: 'Post',
            headers: Config.utilities.authorizedHeader(),
            body: JSON.stringify({ id: id })
        }

        return TransferOptionsService.Common.Fetch(Config.service.transferOptions.whiteListDelete, requestOptions);

    },
    /**
* [WHITE_LIST_SAVE]
*/
    WhiteListSave(formData) {

        var requestOptions = {
            method: 'Post',
            headers: Config.utilities.authorizedHeader(),
            body: JSON.stringify(formData)
        }

        return TransferOptionsService.Common.Fetch(Config.service.transferOptions.whiteListSave, requestOptions);

    },
    /**
 * [WHTE_LIST_EDIT]
 */
    WhiteListEdit(id) {

        var requestOptions = {
            method: 'Post',
            headers: Config.utilities.authorizedHeader(),
            body: JSON.stringify({ id: id })
        }

        return TransferOptionsService.Common.Fetch(Config.service.transferOptions.whiteListDetail, requestOptions);

    },
    /**
    * [ROLES]
    */
    Roles() {

        var requestOptions = {
            method: 'Get',
            headers: Config.utilities.authorizedHeader()
        }

        return TransferOptionsService.Common.Fetch(Config.service.transferOptions.roles, requestOptions);

    },
    /**
    * [ROLE_EDIT]
    */
    RoleEdit(login) {

        var requestOptions = {
            method: 'Post',
            headers: Config.utilities.authorizedHeader(),
            body: JSON.stringify({ id: login })
        }

        return TransferOptionsService.Common.Fetch(Config.service.transferOptions.roleEdit, requestOptions);

    },
    /**
    * [ROLE_SAVE]
    */
    RoleSave(formData) {

        var requestOptions = {
            method: 'Post',
            headers: Config.utilities.authorizedHeader(),
            body: JSON.stringify(formData)
        }

        return TransferOptionsService.Common.Fetch(Config.service.transferOptions.roleSave, requestOptions);

    },
    /**
    * [DELETE_ROLE]
    */
    RoleDelete(login) {

        var requestOptions = {
            method: 'Post',
            headers: Config.utilities.authorizedHeader(),
            body: JSON.stringify({ id: login })
        }

        return TransferOptionsService.Common.Fetch(Config.service.transferOptions.roleDelete, requestOptions);

    },
    /**
      * [TRANSFEROPTION_LIST]
      */
    TransferOptionList() {

        var requestOptions = {
            method: 'Get',
            headers: Config.utilities.authorizedHeader()
        }

        return TransferOptionsService.Common.Fetch(Config.service.transferOptions.transferOptionList, requestOptions);

    },
    /**
  * [COUNTRY_LIST]
  */
    CountryList() {

        var requestOptions = {
            method: 'Get',
            headers: Config.utilities.authorizedHeader()
        }

        return TransferOptionsService.Common.Fetch(Config.service.transferOptions.countryList, requestOptions);

    },
    /**
   * [RULE_SAVE]
   */
    RuleSave(formData) {

        var requestOptions = {
            method: 'Post',
            headers: Config.utilities.authorizedHeader(),
            body: JSON.stringify(formData)
        }

        return TransferOptionsService.Common.Fetch(Config.service.transferOptions.ruleSave, requestOptions);

    },
    /** 
    * [GET_RULE]
    */
    GetRule(id) {

        var requestOptions = {
            method: 'Post',
            headers: Config.utilities.authorizedHeader(),
            body: JSON.stringify(id)
        }

        return TransferOptionsService.Common.Fetch(Config.service.transferOptions.getRule, requestOptions);

    },
    /** 
    * [DELETE_RULE]
    */
    DeleteRule(id) {

        var requestOptions = {
            method: 'Post',
            headers: Config.utilities.authorizedHeader(),
            body: JSON.stringify(id)
        }

        return TransferOptionsService.Common.Fetch(Config.service.transferOptions.deleteRule, requestOptions);

    },
    /**
     * [COMMON]
     * @function Fetch
     */
    Common: {
        Fetch(url, requestOptions) {

            return fetch(url, requestOptions)
                .then((response) => {
                    if (response.ok) {
                        return response.json();
                    }
                    else if (response.status === 401) {
                        Service.User.Logout();
                        window.location.reload();

                    } else {
                        throw new Error();
                    }
                }).then((json) => {
                    return json;
                }).catch(function () {
                    return false;
                });

        }
    }
}